import React, { useState, useEffect, useRef } from 'react'
import { Link } from 'react-router-dom'
import { Box } from '@mui/material'
import { CUSTOM_IMG_SEGMENT_COLOR } from '../../../../../constants'
import { D3Pie, D3BarAndPieChart, Loader } from '../../../../../components'
import { useUpdateLhs, useReactQuery } from '../../../../../hooks'
import { decodeSpecialChars, removeHtmlTags, getLogData } from '../../../../../util'
import BarGrid from '../barGrid'
import ReportsService from '../../../../../services/reports.service'
import { Wrapper, D3PieWrapper, RhsWrapper, Heading, Para, LineWrap } from './style'

const PieComponent = (props) => {
  const { pie, bar, id, pageUrlId, StudyId } = props
  const [loading, setLoading] = useState(false)
  const [segmentData, setSegmentData] = useState([])
  const [pieData, setPieData] = useState([{}, {}, {}, {}, {}])
  const [showD3Pie, setShowD3Pie] = useState(false)
  const [pieSettings, setPieSettings] = useState()
  const [containerWidth, setContainerWidth] = useState(0)
  const { updateSubLhsApiLoaded } = useUpdateLhs()
  const domain = (window.location.host.indexOf('insightsassistant') !== -1 ? 'https://' : 'http://') + window.location.host
  const dataId = pie
  
  const [childData, setChildData] = useState()
  const [state, setState] = useState([])
  const divRef = useRef(null)
  
  // ORIGINAL CODE
  const getPersonaData = (index) => {
    setLoading(true)
    ReportsService.getCategoryPersona({ insightsElementId: dataId[index].id })
      .then((resp) => {
        const t = getLogData('GetStudies', 'GetStudies', {}, {StudyId: StudyId})[0]?.Period

        const object = {
          len: segmentData.length,
          id: dataId[index].id,
          key: dataId[index].key,
          color: resp.PersonaColor,
          url: `${domain}/${dataId[index].url}/${pageUrlId}`,
          sectionMinHeight: dataId[index].minHeight,
          personaName: resp.PersonaName,
          personaPercent: resp.PersonaPercent,
          personaDescription: resp.PersonaDescription,
          name: resp.PersonaName,
          value: resp.PersonaPercent,
          description: decodeSpecialChars(removeHtmlTags(resp.PersonaDescription)),
          studyName: t
        }
        setSegmentData((prev) => [...prev, object])

        const obj = { name: resp.PersonaName, value: resp.PersonaPercent, color: object.color }
        const pieArray = pieData
        if (index === 0) {
          pieArray[4] = obj
        } else {
          pieArray[index - 1] = obj
        }

        setPieData(pieArray)
      })
      .catch((error) => console.log(error))
      .finally(() => {
        setLoading(false)
      })
  }

  useEffect(() => {
    if (segmentData.length !== dataId.length) {
      getPersonaData(segmentData.length)
    } else {
      const pieValueCount = pieData.map((d) => d?.value || 0).reduce((a, b) => a + b, 0)
      if (!pieData[3]?.name) {
        pieData[3] = { name: '', value: 100 - pieValueCount, color: '#f1f1f1' }
      }

      setShowD3Pie(true)
      const settings = {
        width: 400,
        height: 400,
        cx: 1,
        cy: 1,
        outerRadius: 190,
        colors: pieData?.map((d) => d.color) || [],
      }
      setPieSettings(settings)
      updateSubLhsApiLoaded(props)
    }
  }, [segmentData])

  const pieSettingsObj = {
    width: 400,
    height: 400,
    cx: 1,
    cy: 1,
    outerRadius: 190,
  }

  useEffect(() => {
    const colorObject = Object.fromEntries( segmentData.map(d => [d.name, d.color]) );

    const stateData = bar?.map(item => ({
      PrimarySegmentName: item.PrimarySegmentName,
      PrimarySegmentValue: item.PrimarySegmentValue,
      SecondarySegmentSet: {
        SecondarySegment: item.SecondarySegmentSet.SecondarySegment.map((seg, index) => ({
          SegmentName: seg.SegmentName,
          SegmentValue: seg.SegmentValue,
          segmentIndex: index,
          show: true,
          clr: colorObject[seg.SegmentName],
          color: colorObject[seg.SegmentName]
        }))
      },
      show: true,
      PeriodName: item.PrimarySegmentName
    })) || [];

    setState(stateData)
  }, [bar, segmentData]);

  useEffect(() => {
    if (!divRef.current) return;
    
    // Use ResizeObserver to detect width changes of the specific div
    const observer = new ResizeObserver((entries) => {
      for (let entry of entries) {
        setContainerWidth(entry.contentRect.width);
      }
    });

    observer.observe(divRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <>
      <Box ref={divRef} style={{width: '100%'}} className='D2BarAndPieChartWrapper customImageRow'>
        {segmentData?.length > 0 && containerWidth && (
          <D3BarAndPieChart rawData={[...segmentData]} settings={{ ...pieSettingsObj, colors: [...pieData].map((d) => d.color) }} heading={segmentData[0].studyName} parentWidth={containerWidth} isPPTModalActive={props.isPPTModalActive} />
        )}
      </Box>
      {showD3Pie && bar?.length > 0 && (
        <Wrapper className='barWrapper'>
          <BarGrid colorPallet={CUSTOM_IMG_SEGMENT_COLOR} parentData={state} oldData={bar} />
        </Wrapper>
      )}
    </>
  )
}

export default PieComponent
